<template>
  <div id="app">
    <header class="site-header">
      <router-link class="brand" to="/">
        <img alt="FirstLine IT Solutions logo" class="brand__logo" src="/firstline-logo.jpeg">
        <div>
          <p class="brand__eyebrow">Reliable technology support</p>
          <h1>FirstLine IT Solutions</h1>
        </div>
      </router-link>

      <nav class="site-nav">
        <router-link to="/">Home</router-link>
        <router-link to="/packages">Packages</router-link>
        <a href="mailto:support@firstlineitsolutions.com">Contact</a>
      </nav>
    </header>

    <router-view />
  </div>
</template>

<style lang="scss">
:root {
  --brand-green: #2dc84d;
  --brand-green-deep: #189537;
  --brand-green-soft: #d9ffe1;
  --brand-black: #09110c;
  --brand-slate: #15211a;
  --brand-cream: #f8fbf6;
  --brand-line: rgba(14, 49, 22, 0.12);
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: "Trebuchet MS", "Segoe UI", sans-serif;
  background:
    radial-gradient(circle at top left, rgba(45, 200, 77, 0.2), transparent 28%),
    linear-gradient(180deg, #fdfefd 0%, #f4faf4 100%);
  color: var(--brand-black);
}

a {
  color: inherit;
  text-decoration: none;
}

button,
input,
select,
textarea {
  font: inherit;
}

#app {
  min-height: 100vh;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1rem clamp(1.2rem, 3vw, 2.4rem);
  background: rgba(248, 251, 246, 0.9);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--brand-line);
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.brand__logo {
  width: 56px;
  height: 56px;
  object-fit: cover;
}

.brand__eyebrow {
  margin: 0 0 0.2rem;
  font-size: 0.78rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--brand-green-deep);
}

.brand h1 {
  margin: 0;
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  letter-spacing: 0.03em;
}

.site-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.site-nav a {
  padding: 0.55rem 0.9rem;
  border-radius: 999px;
  font-weight: 700;
  color: var(--brand-slate);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.site-nav a.router-link-exact-active,
.site-nav a:hover {
  background: var(--brand-black);
  color: #fff;
}

@media (max-width: 760px) {
  .site-header {
    position: static;
    flex-direction: column;
    align-items: flex-start;
  }

  .site-nav {
    width: 100%;
  }
}
</style>
